import { render, staticRenderFns } from "./AppStatisticsCard.vue?vue&type=template&id=c1df54b2&scoped=true"
import script from "./AppStatisticsCard.vue?vue&type=script&lang=js"
export * from "./AppStatisticsCard.vue?vue&type=script&lang=js"
import style0 from "./AppStatisticsCard.vue?vue&type=style&index=0&id=c1df54b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1df54b2",
  null
  
)

export default component.exports